export const GET_CMS_PAGES_START = 'GET_CMS_PAGES_START';
export const GET_CMS_PAGES_SUCCESS = 'GET_CMS_PAGES_SUCCESS';
export const GET_CMS_PAGES_FAILED = 'GET_CMS_PAGES_FAILED';

export const UPDATE_CMS_PAGE_START = 'UPDATE_CMS_PAGE_START';
export const UPDATE_CMS_PAGE_SUCCESS = 'UPDATE_CMS_PAGE_SUCCESS';
export const UPDATE_CMS_PAGE_FAILED = 'UPDATE_CMS_PAGE_FAILED';

export const UPDATE_REWARD_PAGE = 'UPDATE_REWARD_PAGE';

export const getCMSPagesStart = () => ({
  type: GET_CMS_PAGES_START
});

export const getCMSPagesSuccess = (data) => ({
  type: GET_CMS_PAGES_SUCCESS,
  data
});

export const getCMSPagesFailed = (error) => ({
  type: GET_CMS_PAGES_FAILED,
  error
});

export const updateCMSPageStart = () => ({
  type: UPDATE_CMS_PAGE_START
});

export const updateCMSPageSuccess = (data) => ({
  type: UPDATE_CMS_PAGE_SUCCESS,
  data
});

export const updateCMSPageFailed = (error) => ({
  type: UPDATE_CMS_PAGE_FAILED,
  error
});

export const updateRewardPage = (page) => ({
  type: UPDATE_REWARD_PAGE,
  page
});
